module.exports = __webpack_public_path__ + "img/pwa-install-popup-bg.3fb28a14.png";